import { Box, Group, InputLabel, Stack } from '@mantine/core';

import { LABELS } from '../../constants';
import { FiltersState } from '../../routes/Triggers';

import { DateRange, PlatformsSelect } from '@/components';
import { PagesMultiselect } from '@/components/Selects/PagesMultiselect';

type TriggersControlsProps = {
  filters: FiltersState;
  setFilters: (filters: Partial<FiltersState>) => void;
};

export const TriggersControlsPanel = ({ filters, setFilters }: TriggersControlsProps) => {
  return (
    <Group
      className="selectors-wrapper"
      justify="center"
      wrap="nowrap"
      align="flex-start"
      gap="md"
      mb="xl"
    >
      <Box style={{ flex: '0 0 20%', minWidth: 200 }}>
        <PlatformsSelect
          enabledAll={true}
          label={LABELS.PLATFORM}
          value={filters.platform}
          onSelect={(platform) => setFilters({ platform, expertIds: [] })}
        />
      </Box>
      <Stack gap={0} style={{ flex: '1 1 auto', minWidth: 0 }}>
        <InputLabel size="sm" mt={'4px'} htmlFor="experts-pages-select">
          Experts pages
        </InputLabel>
        <PagesMultiselect
          id="experts-pages-select"
          required
          value={filters.expertIds}
          onSelect={(value) => setFilters({ expertIds: value })}
          platform={filters.platform}
        />
      </Stack>
      <Box style={{ flex: '0 0 20%', minWidth: 240 }}>
        <DateRange
          label={LABELS.SELECT_DATES_RANGE}
          placeholder={LABELS.DATE_PICKER_INPUT_PLACEHOLDER}
          value={filters.dates}
          onChange={(dates) => setFilters({ dates })}
        />
      </Box>
    </Group>
  );
};
